import { fetchShopsAction } from "./actions";
import { push } from "connected-react-router";
import { FirebaseTimestamp, db } from "../../firebase";
import {
  collection,
  doc,
  getDocs,
  deleteDoc,
  orderBy,
  updateDoc,
  addDoc,
  query,
} from "firebase/firestore";

export const saveShops = (newShops) => {
  return async (dispatch) => {
    const shops = await fetchShopsWithNoRedux();
    const timestamp = FirebaseTimestamp.now();
    const batch = [];

    // 1. shopsに存在し、newShopsに存在しないカテゴリを削除
    shops.forEach((shop) => {
      const shopExistsInNew = newShops.some(
        (newShop) => newShop.id === shop.id
      );
      if (!shopExistsInNew) {
        //存在しなかったら
        const docRef = doc(db, "shops", shop.id);
        batch.push(deleteDoc(docRef));
      }
    });

    // 2. newShopsに存在し、shopsに存在しないカテゴリを追加
    newShops.forEach((newShop) => {
      const shopExistsInShops = shops.some((shop) => shop.id === newShop.id);
      if (!shopExistsInShops) {
        //存在しなかったら
        const data = {
          id: "",
          sid: newShop.sid,
          name: newShop.name,
          fax: newShop.fax,
          to: newShop.to,
          cc: newShop.cc,
          updated_at: timestamp,
          created_at: timestamp,
        };
        batch.push(addNewDocument(data));
      }
    });

    // 3. shopsとnewShopsの両方に存在するカテゴリを更新
    newShops.forEach((newShop) => {
      const shopExistsInShops = shops.some((shop) => shop.id === newShop.id);
      if (shopExistsInShops) {
        const shopToUpdate = shops.find((shop) => shop.id === newShop.id);
        if (JSON.stringify(shopToUpdate) !== JSON.stringify(newShop)) {
          const docRef = doc(db, "shops", newShop.id);
          const data = {
            id: newShop.id,
            sid: newShop.sid,
            fax: newShop.fax,
            name: newShop.name,
            to: newShop.to,
            cc: newShop.cc,
            updated_at: timestamp,
          };
          batch.push(updateDoc(docRef, data, { merge: true }));
        }
      }
    });

    try {
      await Promise.all(batch);
      dispatch(push("/"));
    } catch (error) {
      console.error("Error synchronizing shops: ", error);
      throw new Error(error);
    }
  };
};

const addNewDocument = async (newData) => {
  const collectionRef = collection(db, "shops");

  try {
    const docRef = await addDoc(collectionRef, newData);
    const newDocumentId = docRef.id;
    const newDataWithId = { ...newData, id: newDocumentId };
    const docRefToUpdate = doc(db, "shops", newDocumentId);
    await updateDoc(docRefToUpdate, newDataWithId);
  } catch (error) {
    console.error("Error adding document: ", error);
  }
};

export const fetchShops = () => {
  return async (dispatch) => {
    const q = query(collection(db, "shops"), orderBy("sid", "asc"));
    const querySnapshot = await getDocs(q);
    const list = [];
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      list.push({
        id: data.id,
        sid: data.sid,
        fax: data.fax,
        name: data.name,
        to: data.to,
        cc: data.cc,
      });
    });
    // console.log("list:",list);
    dispatch(fetchShopsAction(list));
  };
};

const fetchShopsWithNoRedux = async () => {
  const q = query(collection(db, "shops"), orderBy("id", "asc"));
  const querySnapshot = await getDocs(q);
  const list = [];
  querySnapshot.forEach((doc) => {
    const data = doc.data();
    list.push({
      id: doc.id,
      sid: data.sid,
      name: data.name,
      fax: data.fax,
      to: data.to,
      cc: data.cc,
    });
  });
  return list;
};
